import styled from 'styled-components';

const Body = styled.div`
	display: flex;
	flex-direction: column;
`;

export default Body;
